"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TrustBox = function (_a) {
    var trustBoxRef = _a.trustBoxRef;
    return (React.createElement("div", { ref: trustBoxRef, className: "trustpilot-widget", "data-locale": "en-US", "data-template-id": "53aa8807dec7e10d38f59f32", "data-businessunit-id": "559eaf340000ff000580eae7", "data-style-height": "150px", "data-style-width": "100%", "data-theme": "light" },
        React.createElement("a", { href: "https://uk.trustpilot.com/review/allianz.co.uk", target: "_blank", rel: "noopener" }, "Trustpilot")));
};
var TrustBoxContainer = /** @class */ (function (_super) {
    __extends(TrustBoxContainer, _super);
    function TrustBoxContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.trustBoxRef = React.createRef();
        return _this;
    }
    TrustBoxContainer.prototype.componentDidMount = function () {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    };
    TrustBoxContainer.prototype.render = function () {
        return React.createElement(TrustBox, { trustBoxRef: this.trustBoxRef });
    };
    return TrustBoxContainer;
}(React.Component));
exports.default = TrustBoxContainer;
//# sourceMappingURL=TrustpilotWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/TrustpilotWidget.js
// module id = 501
// module chunks = 0